(() => {
  const state = {
    cards: new Map(),
    blocks: [],
    loading: null,
    applying: false,
  };

  const parseMakers = (element) => {
    try {
      const value = JSON.parse(element.dataset.oemMakers || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  };

  const productKey = (element) => {
    const link = element.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : '';
  };

  const rememberCards = (root) => {
    root.querySelectorAll('[data-oem-product="true"]').forEach((card) => {
      const key = productKey(card);
      if (key) state.cards.set(key, card.cloneNode(true));
    });
  };

  const fetchAllPages = async () => {
    if (state.loading) return state.loading;
    state.loading = (async () => {
      rememberCards(document);
      const grid = document.querySelector('#product-grid[data-id], #product-rows[data-id]');
      if (!grid) return;
      state.blocks = [...grid.children]
        .map((node, index) => ({ node, index }))
        .filter((entry) => !entry.node.matches('[data-oem-product="true"]'))
        .map((entry) => ({ index: entry.index, node: entry.node.cloneNode(true) }));
      const sectionId = grid.dataset.id;
      const urls = new Set();
      document.querySelectorAll('.pagination a[href*="page="]').forEach((link) => urls.add(link.href));
      await Promise.all([...urls].map(async (pageUrl) => {
        const url = new URL(pageUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.toString(), { credentials: 'same-origin' });
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        rememberCards(doc);
      }));
    })();
    return state.loading;
  };

  const selectedMaker = () => document.querySelector('[data-oem-maker-filter]:checked')?.value || '';

  const updateCounts = (controls) => {
    controls.forEach((control) => {
      const count = [...state.cards.values()].filter((card) => parseMakers(card).includes(control.value)).length;
      const output = control.closest('label')?.querySelector('[data-oem-maker-count]');
      if (output) output.textContent = String(count);
      control.disabled = count === 0;
    });
  };

  const applyFilter = async (maker) => {
    if (state.applying) return;
    state.applying = true;
    try {
      await fetchAllPages();
      const grid = document.querySelector('#product-grid[data-id], #product-rows[data-id]');
      if (!grid) return;
      const matches = [...state.cards.values()].filter((card) => !maker || parseMakers(card).includes(maker));
      const nodes = matches.map((card) => card.cloneNode(true));
      state.blocks.forEach((block) => nodes.splice(Math.min(block.index, nodes.length), 0, block.node.cloneNode(true)));
      grid.replaceChildren(...nodes);
      const collection = grid.closest('.collection');
      let empty = collection?.querySelector('[data-oem-maker-empty]');
      if (!matches.length && collection) {
        if (!empty) {
          empty = document.createElement('p');
          empty.dataset.oemMakerEmpty = 'true';
          empty.className = 'collection-empty';
          empty.textContent = 'No products match this car maker.';
          collection.appendChild(empty);
        }
        empty.hidden = false;
      } else if (empty) {
        empty.hidden = true;
      }
      document.querySelectorAll('.pagination-wrapper, ajax-paginate').forEach((node) => { node.hidden = true; });
      const clear = document.querySelector('[data-oem-maker-clear]');
      if (clear) clear.hidden = !maker;
      const url = new URL(window.location.href);
      if (maker) url.searchParams.set('oem_car_maker', maker);
      else url.searchParams.delete('oem_car_maker');
      window.history.replaceState({}, '', url);
    } finally {
      state.applying = false;
    }
  };

  const init = () => {
    const controls = [...document.querySelectorAll('[data-oem-maker-filter]')];
    if (!controls.length) return;
    document.querySelectorAll('[data-name="filter.v.m.car.ids"]').forEach((facet) => facet.remove());
    const facet = document.querySelector('.oem-car-maker-filter');
    if (facet) facet.hidden = false;
    const initial = new URL(window.location.href).searchParams.get('oem_car_maker') || '';
    controls.forEach((control) => {
      control.checked = control.value === initial;
      control.addEventListener('change', () => {
        controls.forEach((other) => { if (other !== control) other.checked = false; });
        applyFilter(control.checked ? control.value : '');
      });
    });
    document.querySelector('[data-oem-maker-clear]')?.addEventListener('click', () => {
      controls.forEach((control) => { control.checked = false; });
      applyFilter('');
    });
    fetchAllPages().then(() => {
      updateCounts(controls);
      applyFilter(initial);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
